<div style="height: 100%; display: flex; position: relative; flex-direction: column;">
  <div style="width: 100%;" *ngIf="!isTablet">
    <img class="home-page-background-image" [src]="backgroundImage" />
  </div>

  <section class="home-page-wrapper disable-select">
    <div class="flex-column">
      <div class="home-page-content-wrapper">
        <mat-tab-group class="home-page-content"
                      [ngClass]="{'supports-single-only': (supportsDelivery && !supportsCollection) || (!supportsDelivery && supportsCollection)}"
                      [(selectedIndex)]="selectedTabIndex">
          <!-- Delivery -->
          <mat-tab class="home-page-content-tab" *ngIf="supportsDelivery">
            <ng-template mat-tab-label>
              <div class="home-page-content-tab-header">
                <div class="home-page-content-tab-header-label">Delivery</div>
                <div class="home-page-content-tab-header-estimate flex-row flex-center" *ngIf="estimatedDeliveryTime">
                  <mat-icon>schedule</mat-icon>
                  <span>{{ estimatedDeliveryTime }}</span>
                </div>
              </div>
            </ng-template>

            <div class="delivery-tab flex flex-center" *ngIf="isLoadingModal">
              <div class="lds-dual-ring"></div>
            </div>

            <div class="delivery-tab flex-column flex-center" [class.hidden]="isLoadingModal">
              <app-home-page-delivery-tab style="width: 100%;"
                                          (onNoStoresFound)="onNoStoresFound($event)"
                                          (onSelection)="openConfirmWantedTimeModal(orderOccasion.Delivery, $event.site, $event.postcode)">
              </app-home-page-delivery-tab>

            </div>
          </mat-tab>

          <!-- Collection -->
          <mat-tab class="home-page-content-tab" *ngIf="supportsCollection">
            <ng-template mat-tab-label>
              <div class="home-page-content-tab-header">
                <div class="home-page-content-tab-header-label">Collection</div>
                <div class="home-page-content-tab-header-estimate flex-row flex-center" *ngIf="estimatedCollectionTime">
                  <mat-icon>schedule</mat-icon>
                  <span>{{ estimatedCollectionTime }}</span>
                </div>
              </div>
            </ng-template>

            <div class="takeaway-tab flex flex-center" *ngIf="loadingSites || isLoadingModal">
              <div class="lds-dual-ring"></div>
            </div>

            <div class="takeaway-tab" [class.hidden]="loadingSites || isLoadingModal">
              <app-home-page-collection-tab [noStoresFound]="noStoresFound"
                                            [sites]="allSites"
                                            (onSelection)="openConfirmWantedTimeModal(orderOccasion.Collection, $event)">
              </app-home-page-collection-tab>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>

      <mat-card class="home-page-content-card" *ngIf="topHtmlSection">
        <div class="home-page-landing-copy-container">
          <div class="home-page-section-group-details-text" [innerHTML]="topHtmlSection.Content"></div>
        </div>
      </mat-card>
    </div>

    <img class="home-page-background-mobile-image" [src]="backgroundImage" style="width: 100%;" *ngIf="isTablet" />

    <mat-card class="home-page-content-card" *ngIf="socialMediaSection">
      <div class="home-page-landing-copy-container">
        <div class="home-page-section-group-details-text" [innerHTML]="socialMediaSection.Content"></div>
      </div>
    </mat-card>

    <span style="flex: 1;"> </span>
    <!-- Carousel -->
    <app-home-page-carousel-tab [carouselSlides]="carouselSlides"></app-home-page-carousel-tab>
    <app-footer></app-footer>
  </section>
</div>

<ng-template #confirmWantedTime>
  <app-wanted-time-picker [basket]="basket"
                          [useBasketForInitialTime]="false"
                          [showWantedTimeIssue]="false"
                          [site]="selectedStore"
                          (onWantedTimeUpdated)="onWantedTimeUpdated($event)"></app-wanted-time-picker>
</ng-template>
